const ORDER_STATUS = {
    PENDING: "PENDING",
    UNPAID: "PAYMENT_PENDING",
    CONFIRMED: "CONFIRMED",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED",
    DELIVERY_ORDER:"DELIVERY_ORDER",
    REFUND_ORDER:"REFUND_ORDER",
    PROCESSING:"PROCESSING",
    REFUNDED:"REFUNDED"

}

export default ORDER_STATUS;